import * as i0 from '@angular/core';
import { InjectionToken, Optional, Inject, Injectable, makeEnvironmentProviders } from '@angular/core';
import { getProvideKey, getProvideKeyByType } from '@noda-lib/utils/src';
import { HttpContextToken, HTTP_INTERCEPTORS } from '@angular/common/http';
import { toHttpHeaders } from '@noda-lib/utils/http';

/* eslint-disable @typescript-eslint/naming-convention */
const INTERCEPTOR_DEFAULT_CONFIG = new InjectionToken('INTERCEPTOR_DEFAULT_CONFIG');
function withDefaultConfig(defaultConfig) {
  const useKey = getProvideKey(defaultConfig);
  const provider = {
    provide: INTERCEPTOR_DEFAULT_CONFIG,
    [useKey]: defaultConfig
  };
  return provider;
}
const INTERCEPTOR_TAGS_MAP_HANDLER = new InjectionToken('INTERCEPTOR_TAGS_MAP_HANDLER');
function withTagsUrlsHandler(handler, type = 'default') {
  const useKey = getProvideKeyByType(type);
  const provider = {
    provide: INTERCEPTOR_TAGS_MAP_HANDLER,
    [useKey]: handler
  };
  return provider;
}
const INTERCEPTOR_TAGS_MAP = new InjectionToken('INTERCEPTOR_TAGS_MAP');
function withTagsUrlsMap(tagsMap) {
  const useKey = getProvideKey(tagsMap);
  const provider = {
    provide: INTERCEPTOR_TAGS_MAP,
    [useKey]: tagsMap
  };
  return provider;
}

/* eslint-disable @typescript-eslint/naming-convention */
const INTERCEPTOR_HEADERS = new InjectionToken('INTERCEPTOR_HEADERS');
function withHeaders(headers) {
  const useKey = getProvideKey(headers);
  const provider = {
    provide: INTERCEPTOR_HEADERS,
    [useKey]: headers
  };
  return provider;
}
const INTERCEPTOR_HEADERS_HANDLER = new InjectionToken('INTERCEPTOR_HEADERS_HANDLER');
function withHeadersHandler(handler, type = 'default') {
  const useKey = getProvideKeyByType(type);
  const provider = {
    provide: INTERCEPTOR_HEADERS_HANDLER,
    [useKey]: handler
  };
  return provider;
}
const SKIP_REQUEST_MODIFICATION = new HttpContextToken(() => false);
const SKIP_HEADERS_MODIFICATION = new HttpContextToken(() => false);
let RequestsInterceptor = /*#__PURE__*/(() => {
  class RequestsInterceptor {
    constructor(defaultConfig, tagMapHandler = null, tagsMap = null, headers = null, headersHandler = null) {
      this.defaultConfig = defaultConfig;
      this.tagMapHandler = tagMapHandler;
      this.tagsMap = tagsMap;
      this.headers = headers;
      this.headersHandler = headersHandler;
    }
    intercept(req, next) {
      const isCanModification = !req.context.get(SKIP_REQUEST_MODIFICATION);
      if (isCanModification) {
        const url = this.makeUrl(req);
        const isSkipHeaders = req.context.get(SKIP_HEADERS_MODIFICATION);
        const meta = {
          url
        };
        const isExistHeaders = Boolean(this.headers?.headers) || Boolean(this.headersHandler);
        if (isExistHeaders && !isSkipHeaders) {
          const headers = this.headersHandler ? this.headersHandler(req) : this.headers;
          meta.headers = toHttpHeaders(headers.headers, req.headers);
        }
        const cloneReq = req.clone(meta);
        return next.handle(cloneReq);
      }
      return next.handle(req);
    }
    makeUrl(req) {
      if (this.tagMapHandler) {
        const url = this.tagMapHandler(req.url, req);
        if (url) return url;
      }
      return this.replaceHostTag(req.url);
    }
    replaceHostTag(url) {
      const tagsMap = Object.assign({}, this.tagsMap);
      if (this.defaultConfig) {
        const {
          API_HOST,
          API_TAG
        } = this.defaultConfig;
        tagsMap[API_TAG] = API_HOST;
      }
      const tagEntry = Object.entries(tagsMap).find(([tag]) => url.startsWith(`${tag}/`));
      if (tagEntry) {
        const [hostTag, replacement] = tagEntry;
        return url.replace(hostTag, replacement);
      }
      return url;
    }
    static {
      this.ɵfac = function RequestsInterceptor_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RequestsInterceptor)(i0.ɵɵinject(INTERCEPTOR_DEFAULT_CONFIG, 8), i0.ɵɵinject(INTERCEPTOR_TAGS_MAP_HANDLER, 8), i0.ɵɵinject(INTERCEPTOR_TAGS_MAP, 8), i0.ɵɵinject(INTERCEPTOR_HEADERS, 8), i0.ɵɵinject(INTERCEPTOR_HEADERS_HANDLER, 8));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: RequestsInterceptor,
        factory: RequestsInterceptor.ɵfac
      });
    }
  }
  return RequestsInterceptor;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function provideUtilsInterceptor(...features) {
  const providers = [RequestsInterceptor, {
    provide: HTTP_INTERCEPTORS,
    useClass: RequestsInterceptor,
    multi: true
  }];
  return makeEnvironmentProviders(providers.concat(...features));
}

/**
 * Generated bundle index. Do not edit.
 */

export { INTERCEPTOR_DEFAULT_CONFIG, INTERCEPTOR_HEADERS, INTERCEPTOR_HEADERS_HANDLER, INTERCEPTOR_TAGS_MAP, INTERCEPTOR_TAGS_MAP_HANDLER, RequestsInterceptor, SKIP_HEADERS_MODIFICATION, SKIP_REQUEST_MODIFICATION, provideUtilsInterceptor, withDefaultConfig, withHeaders, withHeadersHandler, withTagsUrlsHandler, withTagsUrlsMap };
